import { __rest } from 'tslib';
import React from 'react';
import { s as styled } from './styled-112a8bd0.js';
import { space } from 'styled-system';

const StyledCheckbox = styled.div(space, ({ theme, checked, circle, indeterminate = false, width, height }) => {
    const checkedColor = checked || indeterminate ? theme.brand.primary : '#BCBFD6';
    const styles = {
        width,
        height,
        border: circle || !checked ? `1px solid ${checkedColor}` : 'none',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        overflow: 'hidden',
    };
    if (circle) {
        styles.borderRadius = '50% !important';
    }
    if (checked || indeterminate) {
        styles['&:after'] = {
            content: '" "',
            width: `calc(${width} - ${circle || indeterminate ? 6 : 0}px)`,
            height: `calc(${height} - ${circle || indeterminate ? 6 : 0}px)`,
            backgroundColor: checkedColor,
            borderRadius: circle ? '50%' : 'initial',
        };
        if (checked && !circle) {
            styles['&:before'] = {
                position: 'absolute',
                display: 'table',
                border: '2px solid #fff',
                borderTop: 0,
                borderLeft: 0,
                transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
                content: '" "',
                top: '44%',
                left: '50%',
                width: '5px',
                height: '9px',
                transformOrigin: 'left top',
            };
        }
    }
    return styles;
});
const Checkbox = (_a) => {
    var { className, width = '0.9rem', height = '0.9rem' } = _a, rest = __rest(_a, ["className", "width", "height"]);
    return (React.createElement(StyledCheckbox, Object.assign({ width: width, height: height }, rest, { className: className })));
};

export { Checkbox as C };
